import { createAction, props } from '@ngrx/store';

import { CopyTreatmentsStarted, CompletedCopyTreatments } from '../copy-advice.models';

export const copyTreatmentsStarted = createAction(
  '[Copy advice] Copy treatments started',
  props<CopyTreatmentsStarted>(),
);

export const completedCopyTreatments = createAction(
  '[Copy advice] Completed copy treatments',
  props<CompletedCopyTreatments>(),
);

export const completedCopyTreatmentsError = createAction(
  '[Copy advice] Completed copy treatments failed',
);

export const completedCopyAll = createAction('[Copy advice] Completed copy all');

export const copyDialogDismissed = createAction('[Copy advice] Copy dialog dismissed');

export const dismissCopyAdviceStatus = createAction('[Copy advice] Dismiss copy advice status');
